import React from 'react';

import Icon from '../Icon/Icon';

const TncIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M11 10C11 8.89543 11.8954 8 13 8H43C44.1046 8 45 8.89543 45 10V54C45 55.1046 44.1046 56 43 56H13C11.8954 56 11 55.1046 11 54V10Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.75 15C14.75 14.3096 15.3096 13.75 16 13.75H40C40.6904 13.75 41.25 14.3096 41.25 15C41.25 15.6904 40.6904 16.25 40 16.25H16C15.3096 16.25 14.75 15.6904 14.75 15Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.75 39C14.75 38.3096 15.3096 37.75 16 37.75H32C32.6904 37.75 33.25 38.3096 33.25 39C33.25 39.6904 32.6904 40.25 32 40.25H16C15.3096 40.25 14.75 39.6904 14.75 39Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.75 23C14.75 22.3096 15.3096 21.75 16 21.75H40C40.6904 21.75 41.25 22.3096 41.25 23C41.25 23.6904 40.6904 24.25 40 24.25H16C15.3096 24.25 14.75 23.6904 14.75 23Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.75 31C14.75 30.3096 15.3096 29.75 16 29.75H40C40.6904 29.75 41.25 30.3096 41.25 31C41.25 31.6904 40.6904 32.25 40 32.25H16C15.3096 32.25 14.75 31.6904 14.75 31Z'
                fill='#00D1D2'
            />
            <circle
                cx='44'
                cy='44'
                r='11'
                transform='rotate(-180 44 44)'
                fill='#FFFDFB'
                stroke='#393E44'
                strokeWidth='2.5'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M49.6718 38.9658C50.1157 39.2943 50.2093 39.9205 49.8808 40.3645L43.619 48.826C43.437 49.0719 43.1525 49.221 42.8467 49.2306C42.541 49.2403 42.2476 49.1095 42.0505 48.8756L38.1584 44.2572C37.8025 43.8349 37.8563 43.204 38.2787 42.8481C38.701 42.4922 39.3319 42.5461 39.6878 42.9684L42.7642 46.6189L48.2731 39.1747C48.6016 38.7308 49.2278 38.6372 49.6718 38.9658Z'
                fill='#393E44'
            />
        </Icon>
    );
};

export default TncIcon;
